import React from 'react'
import { WrapperFiltersCP } from 'submodules/nerit-framework-ui/features/common/components/filters/wrapper-filters/WrapperFiltersCP'
import { RowCP } from 'submodules/nerit-framework-ui/common/components/grid/row/RowCP'
import { ColumnCP } from 'submodules/nerit-framework-ui/common/components/grid/column/ColumnCP'
import { InputCP } from 'submodules/nerit-framework-ui/common/components/form-fields/input/InputCP'
import { ButtonCP } from 'submodules/nerit-framework-ui/common/components/button/ButtonCP'
import { IFormStateManager } from 'submodules/nerit-framework-ui/common/form-state-manager/types/IFormStateManager'
import { LocationsFiltersFormModel } from 'modules/locations/components/filters/filters-locations/inner/LocationsFiltersFormModel'
import { SelectSamplingsCP } from 'modules/samplings/components/select-samplings/SelectSamplingsCP'
import { useEnterKeySearch } from 'submodules/nerit-framework-ui/common/responsiveness/use-enter-key-search/UseEnterKeySearch'

interface ICPProps {
    formStateManager: IFormStateManager<LocationsFiltersFormModel>
    onFilter: () => void
    isLoading?: boolean
}

/**
 */
export function FiltersLocationsCP(props: ICPProps): JSX.Element {

    useEnterKeySearch(props.onFilter)

    return (
        <WrapperFiltersCP
            filters={
                <RowCP>
                    <ColumnCP size={12}>
                        <InputCP
                            formStateManager={props.formStateManager}
                            fieldName={'searchString'}
                            label={'Pesquise pelo ponto'}
                            allowClear={true}
                        />
                    </ColumnCP>
                    <ColumnCP size={12}>
                        <SelectSamplingsCP
                            formStateManager={props.formStateManager}
                            fieldName={'samplingCode'}
                            isRequired={false}
                        />
                    </ColumnCP>
                </RowCP>
            }
            filterButton={
                <ButtonCP
                    icon={'search'}
                    type={'primary'}
                    onClick={props.onFilter}
                    loading={props.isLoading}
                />
            }
        />
    )
}
